/**
 * String utility functions for text normalization and comparison
 */

/**
 * Normalize string by removing accents and special characters
 * Useful for comparing strings with different accents (e.g., "Citroën" vs "Citroen")
 * @param {string} str - String to normalize
 * @returns {string} Normalized string (lowercase, no accents, alphanumeric and hyphens only)
 */
export function normalizeString(str) {
    if (!str) return '';

    // Convert to lowercase first
    str = str.toLowerCase();

    // Replace common accented characters
    return str
        .normalize('NFD')                     // Normalize to decomposed form
        .replace(/[\u0300-\u036f]/g, '')     // Remove accent marks
        .replace(/[^a-z0-9- ]/g, '');         // Remove non-alphanumeric chars except hyphens
}

/**
 * Check if two strings are equal after normalization
 * @param {string} str1 - First string to compare
 * @param {string} str2 - Second string to compare
 * @returns {boolean} True if strings are equal after normalization
 */
export function normalizedEquals(str1, str2) {
    return normalizeString(str1) === normalizeString(str2);
}
